import { DisconnectedReason } from 'app/store/connectivity/ConnectivityState';
import NetworkState from 'communication/NetworkState';

import {
    setConnected,
    setDisconnected as setDisconnectedAction,
} from './connectivityStateSlice';
export { setConnected } from './connectivityStateSlice';

export const setDisconnected = (
    reason: DisconnectedReason,
    lostConnectionStatus?: NetworkState
) => setDisconnectedAction({ reason, lostConnectionStatus });

export type SetConnectedAction = ReturnType<typeof setConnected>;
export type SetDisconnectedAction = ReturnType<typeof setDisconnected>;
